import React from 'react';
import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  return (
    <div className="error-container">
      <div className="error-icon">⚠️</div>
      <h2 className="error-title">Configuration Error</h2>
      <p className="error-message">{message}</p>
      <div className="error-details">
        <p>Please ensure the following parameters are provided in the URL:</p>
        <ul>
          <li><code>truckId</code> - The unique identifier for the truck</li>
          <li><code>vendorId</code> - The unique identifier for the vendor</li>
        </ul>
        <p>Optional parameter:</p>
        <ul>
          <li><code>environment</code> - Set to "app" or "dev" (defaults to "app")</li>
        </ul>
        <p className="example">
          Example: <code>?truckId=123&vendorId=456&environment=dev</code>
        </p>
      </div>
    </div>
  );
};

export default ErrorMessage;
